<script type="text/javascript">
const colorList = [
  '#F9F900',
  '#6FB7B7',
  '#9999CC',
  '#B766AD',
  '#B87070',
  '#FF8F59',
  '#FFAF60',
  '#FFDC35',
  '#FFFF37',
  '#B7FF4A',
  '#28FF28',
  '#1AFD9C',
  '#00FFFF',
  '#2894FF',
  '#6A6AFF',
  '#BE77FF',
  '#FF77FF',
  '#FF79BC',
  '#FF2D2D',
  '#ADADAD'
]
const colorListLength = 20

const APIHost = 'https://ylw.0735520.com/api' // api 主机头
const PICHost = 'http://qpic.07358.com/' // 图片主机头

// 获取随机色
function getRandColor () {
  var tem = Math.round(Math.random() * colorListLength)
  return colorList[tem]
}

const LG = {
  STATUS_0 : '已推荐',
  STATUS_1 : '已分配',
  STATUS_2 : '跟进中',
  STATUS_3 : '已认筹',
  STATUS_4 : '已定金',
  STATUS_5 : '已成交',
  STATUS_6 : '已失效',
  // STATUS_7 : '已结佣',
  STATUS_10 : '已完成',
  STATUS_20 : '已失效',
}

export default
{
  colorList,
  colorListLength,
  getRandColor,
  APIHost,
  PICHost,
  LG,
}
</script>



// WEBPACK FOOTER //
// config.vue?2ff84e87